import request from '@/utils/request/index'

export default {
  // 设置时间
  setTimerData(params) {
    return request.post('/v1/front/lab/data/pub/setTimerData', params)
  },
  // 获取断路器相关数据
  getOutsideLogicData(params) {
    return request.post('/v1/front/lab/data/outsideLogic/getOutsideLogicData', params)
  },
  // 获取保护装置电流继电器实验数据
  getProtDeviceCurrentRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getCurrentRelay', params)
  },
  // 获取保护装置电压继电器实验数据
  getProtDeviceVoltRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getVoltRelay', params)
  },
  // 获取保护装置功率方向继电器实验数据
  getProtDevicePowerRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getPowerRelay', params)
  },
  // 获取保护装置差动继电器实验数据
  getProtDeviceDifferRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getDifferRelay', params)
  },
  // 获取保护装置阻抗继电器实验数据
  getProtDeviceImpedanceRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getImpedanceRelay', params)
  },
  // 获取保护装置反时限继电器实验数据
  getProtDeviceAntiTimeRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getAntiTimeRelay', params)
  },
  // 获取保护装置负序继电器实验数据
  getProtDeviceNegvoltRelayData(params) {
    return request.post('/v1/front/lab/data/protDeviceRelay/getNegvoltRelay', params)
  },
  // 获取保护装置低电压线路保护实验数据
  getProtDeviceLowVoltageLineData(params) {
    return request.post('/v1/front/lab/data/protDeviceVoltageLine/getLowVoltageLine', params)
  },
  // 获取保护装置高电压线路保护实验数据
  getProtDeviceHighVoltageLineData(params) {
    return request.post('/v1/front/lab/data/protDeviceVoltageLine/getHighVoltageLine', params)
  },
  // 获取保护装置变压器保护实验数据
  getProtDeviceTransfData(params) {
    return request.post('/v1/front/lab/data/protDeviceTransf/getTransfData', params)
  },
  // 获取保护装置发电机保护实验数据
  getProtDeviceGeneratorData(params) {
    return request.post('/v1/front/lab/data/protDeviceGenerator/getGeneratorData', params)
  },
  // 获取保护装置电容器保护实验数据
  getProtDeviceCapData(params) {
    return request.post('/v1/front/lab/data/protDeviceCap/getCapData', params)
  },
  // 获取保护装置电动机保护实验数据
  getProtDeviceMotorData(params) {
    return request.post('/v1/front/lab/data/protDeviceMotor/getMotorData', params)
  },
  // 测试仪init调用
  callCsyInit(params) {
    return request.post('/v1/front/lab/data/csy/init/callCsyInit', params)
  },
  // 获取测试仪的通用测试Init
  getCSYGetUniversalTestInitData(params) {
    return request.post('/v1/front/lab/data/csy/universalTest/getUniversalTestInit', params)
  },
  // 获取测试仪的通用测试
  getCSYGetUniversalTestData(params) {
    return request.post('/v1/front/lab/data/csy/universalTest/getUniversalTest', params)
  },
  // 获取测试仪的阻抗继电器特性测试Init
  getCSYGetLZRelayTestInitData(params) {
    return request.post('/v1/front/lab/data/csy/lzRelay/getLZRelayTestInit', params)
  },
  // 获取测试仪的阻抗继电器特性测试
  getCSYGetLZRelayTestData(params) {
    return request.post('/v1/front/lab/data/csy/lzRelay/getLZRelayTest', params)
  },
  // 获取测试仪的差动继电器特性测试初始化
  getCSYGetLCDRelayTestInitData(params) {
    return request.post('/v1/front/lab/data/csy/lcdRelay/getLCDRelayTestInit', params)
  },
  // 获取测试仪的差动继电器特性测试
  getCSYGetLCDRelayTestData(params) {
    return request.post('/v1/front/lab/data/csy/lcdRelay/getLCDRelayTest', params)
  },
  // 获取测试仪的反时限继电器特性测试 初始化
  getCSYGetAntiTimeRelayTestInitData(params) {
    return request.post('/v1/front/lab/data/csy/antiTimeRelay/getAntiTimeRelayTestInit', params)
  },
  // 获取测试仪的反时限继电器特性测试
  getCSYGetAntiTimeRelayTestData(params) {
    return request.post('/v1/front/lab/data/csy/antiTimeRelay/getAntiTimeRelayTest', params)
  },
  // 获取测试仪的线路整组保护测试数据
  getCSYGetLineProtectData(params) {
    return request.post('/v1/front/lab/data/csy/lineProtect/getLineProtect', params)
  },
  // 获取测试仪的线路整组保护测试数据
  getCSYGetTransfProtectData(params) {
    return request.post('/v1/front/lab/data/csy/transfProtect/getTransfProtect', params)
  },
  // 获取测试仪的电动机保护测试数据
  getCSYGetMotorProtectData(params) {
    return request.post('/v1/front/lab/data/csy/motorProtect/getMotorProtect', params)
  },
  // 获取测试仪的发电机保护测试数据
  getCSYGetGenerProtectData(params) {
    return request.post('/v1/front/lab/data/csy/generProtect/getGenerProtect', params)
  },
  // 获取测试仪的电容器保护测试数据
  getCSYGetCapProtectData(params) {
    return request.post('/v1/front/lab/data/csy/capProtect/getCapProtect', params)
  },
  // 获取测试仪的手动测验初始化数据
  getCSY313UGetManualTest1InitData(params) {
    return request.post('/v1/front/lab/data/csy/313u/getManualTest1Init', params)
  },
  // 获取测试仪的手动测验数据
  getCSY313UGetManualTest1Data(params) {
    return request.post('/v1/front/lab/data/csy/313u/getManualTest1', params)
  },
  // 获取测试仪的手动测验初始化数据
  getCSYTimeTestInitData(params) {
    return request.post('/v1/front/lab/data/csy/timeTest/getTimeTestInit', params)
  },
  // 获取测试仪的手动测验数据
  getCSYTimeTestData(params) {
    return request.post('/v1/front/lab/data/csy/timeTest/getTimeTest', params)
  }

}
